import React from 'react';
import axios from "axios";

//
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  MouseSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from '@dnd-kit/core';

import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import {
  restrictToVerticalAxis,
  restrictToWindowEdges,
  restrictToFirstScrollableAncestor
} from '@dnd-kit/modifiers';
//

import { Container, Grid, useMantineTheme, Box, Group, Table, ScrollArea, Text, Badge, ActionIcon } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { notifications } from '@mantine/notifications';
import { v4 as uuidv4 } from 'uuid';
import { IconReload } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { BE_API_THREE, BE_API_ONE, utils, role } from "../../utils/globalVariables";
import { getPropInSubLevelRole } from "../../utils/globalFunctions";

import NoData from "../../components/general/NoData";
import ColumnComp from "./ColumnComp";

const SortingPriorityIndex = ({ stateMenu, stateSubMenu, stateTab }) => {

  const mountedRef = React.useRef(true);

  const theme = useMantineTheme();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'SortingPriorityIndex-1',
  })

  const [data, setData] = React.useState({
    data: [],
    dataFlag: 'idle',
    dataLoading: false,
    dataRefresh: new Date(),
    dragPointTouched: false,
    hapus1: '',
    utilsAllHeight: 0
  });

  React.useEffect(() => {
    return () => {
      // mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    setData(d => ({ ...d, dataLoading: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('teknisi_flag', role.teknisi.slugLevel);
    formDT.append('owner_flag', role.owner.slugLevel);

    axios({
      method: 'post',
      url: BE_API_ONE + '/get_data_prioritas_index',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, dataLoading: false }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          data: response.data.data_project_teknisi,
          dataFlag: response.data.data_project_teknisi.length > 0 ? true : false,
        }));
      }

      if (response.data.flag_status === 'no-data-teknisi') {
        //
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, dataLoading: false }));

      notifications.show({
        id: notificationId.current.errorGetData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }, [handleSetLoginContext, loginContext.syswebapp, data.dataRefresh])

  React.useEffect(() => {
    const el = document.querySelector('#agu');

    setTimeout(() => {
      el?.classList.add('asu');
    }, 100);

    return () => {
      el?.classList.remove('asu');
      document.querySelector('html').classList.remove('preventPull');
    }
  }, [])

  let headerNavComponentHeight = React.useRef(0);
  let tabNavBarHeight = React.useRef(0);
  let teknisiNameHeight = React.useRef(0);

  React.useEffect(() => {
    const headerNavComponent = document.querySelector(".headerNavComponent");
    const tabNavBar = document.querySelector(".tabNavBar");
    const teknisiName = document.querySelector(".teknisiName");

    headerNavComponentHeight.current = headerNavComponent ? headerNavComponent.offsetHeight : 0;
    tabNavBarHeight.current = tabNavBar ? tabNavBar.offsetHeight : 0;
    teknisiNameHeight.current = teknisiName ? teknisiName.offsetHeight : 0;

    setData(d => ({ ...d, utilsAllHeight: headerNavComponentHeight.current + tabNavBarHeight.current + teknisiNameHeight.current }))
  }, [])

  return (
    <React.Fragment>
      <Container fluid>
        <Grid my={0}>
          {(data.data.length <= 0) && (data.dataFlag !== 'idle') && !data.dataLoading &&
            <Grid.Col span={12}>
              <div
                style={{
                  height: `calc(100svh - var(--mantine-header-height, 0px) - ${data.utilsAllHeight}px - 4.5rem)`,
                  maxHeight: `calc(100svh - var(--mantine-header-height, 0px) - ${data.utilsAllHeight}px - 4.5rem)`
                }}
              >
                <NoData />
              </div>
            </Grid.Col>
          }

          {data.dataLoading &&
            <Grid.Col span={12}>
              <div
                style={{
                  height: `calc(100svh - var(--mantine-header-height, 0px) - ${data.utilsAllHeight}px - 4.5rem)`,
                  maxHeight: `calc(100svh - var(--mantine-header-height, 0px) - ${data.utilsAllHeight}px - 4.5rem)`
                }}
              >
                <Text ta='center' mt='2rem' size='sm'>
                  Loading Data..
                </Text>
              </div>
            </Grid.Col>
          }

          {(data.data.length > 0) && (data.dataFlag !== 'idle') && !data.dataLoading &&
            <Grid.Col
              span={12}
              pt='xs'
              pb={0}
            >
              <div
                id='xxx'
                style={{
                  display: 'flex',
                  gap: '8px',
                  overflowX: 'scroll',
                }}
              >
                {!data.dataLoading && Array.isArray(data.data) && (data.data.length > 0) && Object.keys(data.data).map((keyD, idxD) => {
                  return (
                    <ColumnComp
                      key={idxD}
                      stateData={data.data[keyD]}
                      stateUtilsAllHeight={data.utilsAllHeight}
                      stateId={idxD}

                      fnDragPointTouched={(e) => {
                        window.document.getElementById(`${idxD}yyy`).style.backgroundColor = theme.colorScheme === 'light' ? theme.colors.blue[1] : theme.colors.dark[4];
                        document.querySelector('#xxx').style.overflow = 'hidden';
                      }}

                      fnDragPointUntouched={(e) => {
                        window.document.getElementById(`${idxD}yyy`).style.backgroundColor = theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[6];

                        document.querySelector('#xxx').style.overflow = 'scroll';
                      }}

                      fnSuccessSetTeknisi={() => setData(d => ({ ...d, dataRefresh: new Date() }))}
                    />
                  )
                })}
              </div>
            </Grid.Col>
          }
        </Grid>
      </Container>
    </React.Fragment>
  )
}

export default SortingPriorityIndex;